
/* injects from baggage-loader */

'use strict';

const moduleLayoutEditor = angular.module('services.layoutEditor', [
  'wysiwyg.initializer',
  'timer.initializer',
  'form.initializer',
  'subscribe_form.initializer',
  'spacer.initializer',
  'slider.initializer',
  'parallax.initializer',
  'contentAnimate.initializer',
  'contentEditable.initializer',
  'bgSlideShow.initializer',
  'map.initializer',
  'button_actions.initializer',
  'image.initializer',
  'services.editorNamespace',
  'services.layoutEditor.insertSpace',
  'services.layoutEditor.blockDragDrop',
  'services.layoutEditor.blocksBuilder',
  'services.layoutEditor.editorDragPanel',
  'services.layoutEditor.insertBlockMenu',
  'services.layoutEditor.sectionDragDrop',
  'services.layoutEditor.blockEditDialog',
  'services.layoutEditor.blockDropOverlays',
  'services.layoutEditor.blockOverlays',
  'services.layoutEditor.blockDragScroll',
  'services.layoutEditor.timemachine',
  'services.layoutEditor.timemachine.acts'
]);

moduleLayoutEditor.factory('layoutEditor', [
  '$timeout', 'Template', 'insertSpace', 'blockDragDrop', 'blockDropOverlays', 'sectionDragDrop', 'ns',
  'blocksBuilder', 'editorDragPanel', 'insertBlockMenu', 'blockEditDialog', 'Text', 'Spacer', 'Section',
  '$state', 'Site', '$window', '$rootScope', 'blockDragScroll', '$injector', 'Notification', 'Slider',
  'MapInit', 'ImageInit', 'ContentEditable', 'Parallax', 'ContentAnimate', 'bgSlideShow', 'TimeMachine',
  'Timer', 'Email', 'SectionEmail', 'SectionWebForm', 'SectionLesson', 'FrameForm', 'SubscribeFormManager',
  'ButtonActionsManager',
  (
    $timeout, Template, insertSpace, blockDragDrop, blockDropOverlays, sectionDragDrop, ns,
    blocksBuilder, editorDragPanel, insertBlockMenu, blockEditDialog, Text, Spacer, Section,
    $state, Site, $window, $rootScope, blockDragScroll, $injector, Notification, Slider,
    MapInit, ImageInit, ContentEditable, Parallax, ContentAnimate, bgSlideShow, TimeMachine,
    Timer, Email, SectionEmail, SectionWebForm, SectionLesson, FrameForm, SubscribeFormManager,
    ButtonActionsManager
  ) => {
    let Y;

    if ($state.current.name === 'email.page.editor') {
      Section = SectionEmail;
    }

    if ($state.current.name === 'form.page.editor') {
      Section = SectionWebForm;
    }

    if (['lesson.page.editor', 'lesson.page.mixer'].indexOf($state.current.name) !== -1) {
      Section = SectionLesson;
    }

    const layoutEditor = {
      /**
       * save
       */
      save: function() {
        const self = this;

        // Действие перед сохранением с использованием текущего layout (# Установка текста перед сохранением)
        Section.beforeSave(self.layout);

        // Обновление текущего layout
        self.layout.section.structure = Section.generateJSON(self.layout.one(ns.wrapperClass));

        // Сохранение json
        self.setJSONtoSection(self.layout.section);
      },

      /**
       * publicSectionSave
       */
      publicSectionSave: function() {
        const self = this;

        Section.save(this.layout).then(function(section) {
          self.setJSONtoSection(section);
          $rootScope.$broadcast("get:styles", section.id);
          Notification.success({
            message: 'Секция успешно сохранена'
          });
        }, function() {
          Notification.error({
            message: 'Извините, что-то пошло не так'
          });
        });
      },

      /**
       * publicEmailSave
       */
      publicEmailSave: function() {
        const self = this;

        Email.save(this.layout).then(function(section) {
          self.setJSONtoSection(section);
          $rootScope.$broadcast("get:styles", section.id);
          Notification.success({
            message: 'Письмо успешно сохранено'
          });
        }, function() {
          Notification.error({
            message: 'Извините, что-то пошло не так'
          });
        });
      },

      /**
       * sortSections
       * @returns {boolean}
       */
      sortSections: function() {
        const ref = Editor.mode;

        const availableEditorModes = [
          'site.page.editor',
          'email.page.editor',
          'lesson.page.editor'
        ];

        if (!availableEditorModes.includes(ref)) {
          return false;
        }

        const sectionsIds = [];
        const sectionlist = Y.all(ns.sectionClass + ":not(.str-removed)");

        sectionlist.each(function(s, index) {
          sectionsIds.push(s.section.id);
        });
        Section.sort(sectionsIds);
      },

      createFromCollection: function() {
        Section.create(this.layout).then(function() {});
      },

      /**
       * setTemplateJSON
       * @param data
       * @returns {boolean}
       */
      setTemplateJSON: function(data) {
        if (!data) {
          return false;
        }
        if (Array.isArray(data)) {
          this.setJSONtoSections(data);
        } else {
          this.setJSONtoSection(data);
        }
      },

      /**
       * setJSONtoSections
       * @param sections
       */
      setJSONtoSections: function(sections) {
        const self = this;
        _.each(sections, function(section) {
          self.setJSONtoSection(section);
        });
      },

      /**
       * setJsonToRows
       * @param rows
       * @param sectionNode
       */
      setJsonToRows: function(rows, sectionNode) {
        const self = this;
        _.each(rows, function(row) {
          _.each(row.cols, function(col) {
            if (col.rows) {
              self.setJsonToRows(col.rows, sectionNode);
            } else {
              _.each(col.widgets, function(widget) {
                const widgetEl = sectionNode.one("[data-block-id=" + widget.id + "]");

                if (widgetEl) {
                  widgetEl.widget = widget;
                }
              });
            }
          });
        });
      },

      /**
       * setJSONtoSection
       * @param section
       */
      setJSONtoSection: function(section) {
        const id = section.id;
        const sectionNode = $rootScope.Y.one(".tpl-wrapper > [data-section-id=" + id + "]");

        if (sectionNode) {
          this.updateSectionEtag(section);

          sectionNode.section = section;
          sectionNode.old_section = section;

          this.setJsonToRows(section.structure.rows, sectionNode);
        }
      },

      /**
       * Deep diff between two object, using lodash
       * @param  {Object} object Object compared
       * @param  {Object} base   Object to compare with
       * @return {Object}        Return a new object who represent the diff
       */
      difference: function (object, base) {
        function changes(object, base) {
          return _.transform(object, function (result, value, key) {
            if (!_.isEqual(value, base[key])) {
              result[key] = (_.isObject(value) && _.isObject(base[key])) ? changes(value, base[key]) : value;
            }
          });
        }

        return changes(object, base);
      },

      /**
       * updateSectionEtag
       * @param section
       */
      updateSectionEtag: function(section) {

        const previousSection = this.getRootScopeParameter('previousSection', section.id);

        if (!!previousSection && !_.isEqual(previousSection, section)) {
          const timestamp = Date.now().toString();

          console.log('Section #' + section.id + ' have update - ' + timestamp);

          section.etag = timestamp;

          this.setRootScopeParameter('previousSection', section.id, section);
          this.setRootScopeParameter('sectionVersions', section.id, timestamp);
        }

        if (!!previousSection === false) {
          this.setRootScopeParameter('previousSection', section.id, section);
        }
      },

      /**
       * getRootScopeParameter
       * @param parameter
       * @param id
       * @returns {*}
       */
      getRootScopeParameter(parameter, id) {
        if ($rootScope[parameter]) {
          return $rootScope[parameter][id] || null;
        } else {
          return null;
        }
      },

      /**
       * setRootScopeParameter
       * @param parameter
       * @param id
       * @param value
       */
      setRootScopeParameter(parameter, id, value) {
        if (!$rootScope[parameter]) {
          $rootScope[parameter] = {};
        }

        $rootScope[parameter][id] = _.cloneDeep(value);
      },

      /**
       * setFontToJsonWidgets
       * @param layout
       * @param fonts
       */
      setFontToJsonWidgets: function(layout, fonts) {
        const default_font = fonts["default"] || "Open Sans";
        const default_h_font = fonts.h || "Open Sans";

        layout.all(".str-bw_navigation").each(function(w) {
          w.widget.style_attributes.fontFamily = default_font;
        });
        layout.all(".str-bw_list").each(function(w) {
          w.widget.style_attributes.fontFamily = default_font;
          w.widget.caption_style.fontFamily = default_font;
        });
        layout.all(".str-bw_form").each(function(w) {
          w.widget.form_fields_style_attributes.fontFamily = default_font;
          w.widget.labels_style_attributes.fontFamily = default_font;
          w.widget.button.style.fontFamily = default_font;
        });
        layout.all(".str-bw_card").each(function(w) {
          w.widget.wrapper_style.fontFamily = "";
          w.widget.title_style.fontFamily = default_h_font;
          w.widget.price_style.fontFamily = default_h_font;
          w.widget.description_style.fontFamily = default_font;
          w.widget.button_attributes.style_attributes.fontFamily = default_font;
        });
        layout.all(".str-bw_button").each(function(w) {
          w.widget.button_attributes.style_attributes.fontFamily = default_font;
          w.widget.button_attributes.style_attributes.fontFamily = default_font;
        });
        layout.all(".str-bw_product").each(function(w) {
          var i, len, productItem, ref, results;
          ref = w.widget.product_items_attributes;
          results = [];
          for (i = 0, len = ref.length; i < len; i++) {
            productItem = ref[i];
            productItem.caption_style_attributes.fontFamily = default_font;
            productItem.text_style_attributes.fontFamily = default_font;
            results.push(productItem.button_attributes.style_attributes.fontFamily = default_font);
          }
          return results;
        });
        layout.all(".str-bw_review").each(function(w) {
          w.widget.text_style.fontFamily = default_font;
          w.widget.name_style.fontFamily = default_h_font;
          w.widget.vocation_style.fontFamily = default_h_font;
        });
        layout.all(".str-bw_link").each(function(w) {
          w.widget.button_attributes.style_attributes.fontFamily = default_font;
        });
        layout.all(".str-bw_slider").each(function(w) {
          w.widget.caption_style.fontFamily = default_font;
        });
      },

      /**
       * initDDsections
       */
      initDDsections: function() {
        const self = this;
        if (!Editor.option) {
          const sectionlist = Y.all(ns.sectionClass);
          sectionlist.each(function(v, k) {
            const tagname = v.get('tagName').toLowerCase();

            if (tagname === "section") {
              self.setHandleSections(v);
            }
            if (tagname === "footer" || tagname === "header") {
              return new Y.DD.Drop({
                node: v
              });
            }
          });
        }
      },

      /**
       * initDDblocks
       */
      initDDblocks: function() {
        this.destroyDDblocks();

        const self = this;
        const blocklist = this.layout.all(ns.blockClass);

        blocklist.each(function(v, k) {
          self.setHandleBlocks(v);
        });
      },

      /**
       * initDDSingle
       * @param v
       * @returns {*}
       */
      initDDSingle: function(v) {
        const dd = new Y.DD.Drag({
          node: v,
          target: {
            padding: '0 0 0 20'
          }
        }).plug(Y.Plugin.DDProxy, {
          cloneNode: true,
          moveOnEnd: false,
          flyBack: false
        });
        return dd;
      },

      /**
       * setHandleBlocks
       * @param v
       */
      setHandleBlocks: function(v) {
        const dd = this.initDDSingle(v);
        const widgetsIsLocked = this.layout.section.lock_widgets && Editor.mode === 'site.page.editor' || Editor.option;

        dd.set('lock', widgetsIsLocked);
        dd.addHandle(ns.dragPanelClass);

        blockDragDrop.setEvents(dd, Y);
      },

      isTouchEnabled: function () {
        return ('ontouchstart' in window) ||
            (navigator.maxTouchPoints > 0) ||
            (navigator.msMaxTouchPoints > 0);
      },

      /**
       * setHandleSections
       * @param v
       */
      setHandleSections: function(v) {
        if (!this.isTouchEnabled()) {
          const dd = this.initDDSingle(v);
          dd.addHandle(ns.dragPanelClass);

          sectionDragDrop.setEvents(dd, Y);
        }
      },

      /**
       * destroyDDblocks
       * @returns {boolean}
       */
      destroyDDblocks: function() {
        if (!this.layout) {
          return false;
        }
        const blocklist = this.layout.all(ns.blockClass);
        this.destroyDDSingle(blocklist);
      },

      /**
       * destroyDDsections
       */
      destroyDDsections: function() {
        const sectionlist = Y.all(ns.sectionClass);
        this.destroyDDSingle(sectionlist);
      },

      /**
       * destroyDDSingle
       * @param list
       * @returns {*}
       */
      destroyDDSingle: function(list) {
        return list.each(function(v, k) {
          var dd, dr, id;
          id = v.get('id');
          dd = Y.DD.DDM.getDrag('#' + id);
          dr = Y.DD.DDM.getDrop('#' + id);
          if (dd) {
            dd.destroy();
          }
          if (dr) {
            dr.destroy();
          }
          if (dd) {
            dd._unprep();
          }
        });
      },

      /**
       * clearWidgetsStyle
       * @param sectionId
       */
      clearWidgetsStyle: function(sectionId) {
        const cssStylesheet = angular.element("#tplStyle").get(0);
        const section = angular.element("[data-section-id='" + sectionId + "']");

        section.find(ns.widgetWrapperClass).removeAttr("style");
      },

      /**
       * templateIsBlank
       * @returns {boolean}
       */
      templateIsBlank: function() {
        return !Y.one(ns.tplContainer).contains(Y.one(ns.sectionClass));
      },

      /**
       * Инициализация редактирования секции
       * @param layout
       */
      initEditingLayout: function(layout) {
        layout.edited = true;
        this.layout = layout;
        this.initDDblocks();

        editorDragPanel.initBlocksPanels();
        blocksBuilder.initResizers();
        Text.init(Y);
        Spacer.init(Y);
        $rootScope.layoutIsEditing = true;
        ContentEditable.bind(layout, true);
        Slider.init(Y);
        $rootScope.$apply();
      },

      /**
       * cancelEditingLayout
       */
      cancelEditingLayout: function() {
        editorDragPanel = $injector.get("editorDragPanel");
        ContentEditable.bind(this.layout, false, false);
        this.destroyDDblocks();
        Text.destroy();
        Spacer.destroy();
        this.layout = null;
        editorDragPanel.removeAllSettingsClasses();
        blockEditDialog.clearCurrentBlockJson();
        if (!$rootScope.$$phase) {
          $rootScope.$apply();
        }
      },

      /**
       * widgetInitializers
       * @param Y
       */
      widgetInitializers: function(Y) {
        Slider.init(Y);
        MapInit.init(Y);
        ContentEditable.init(Y);
        Timer.init(Y);
        FrameForm.init(Y);
        SubscribeFormManager.init(Y);
        ButtonActionsManager.init(Y);
        ImageInit.init(Y);
      },

      /**
       * singleSectionInitializer
       * @param section
       */
      singleSectionInitializer: function(section) {
        Parallax.initSection(section);
        bgSlideShow.initSection(section);
      },

      /**
       * sectionInitializers
       * @param Y
       */
      sectionInitializers: function(Y) {
        if (Y == null) {
          Y = false;
        }
        Parallax.init(Y);
        bgSlideShow.init(Y);
      },

      /**
       * Инициализация layoutEditor, происходит из базовых контроллеров
       * @param y
       */
      initializer: function(y) {
        if (y === null || y === undefined) {
          y = false;
        }
        if (!Y) {
          Y = y;
        }

        this.widgetInitializers(Y);
        this.initDDsections();
        blocksBuilder.init(Y);
        sectionDragDrop.setYUI(Y);
        insertSpace.init(Y);
        blockEditDialog.init(Y);
        insertBlockMenu.init(Y);
        blockDropOverlays.init(Y);
        blockDragScroll.init(Y);
        TimeMachine.init(Y);

        log('layouts initializer');
      },

      /**
       * destroy
       */
      destroy: function() {
        this.destroyDDsections();
        this.destroyDDblocks();
        if (this.layout) {
          this.cancelEditingLayout();
        }
        editorDragPanel.destroy();
        blockEditDialog.destroy();
        insertBlockMenu.destroy();
        insertSpace.destroy();
        Text.destroy();
        editorDragPanel.removeAllSettingsClasses();
        blockEditDialog.clearCurrentBlockJson();

        log('layoutEditor destroy');
      }
    };

    return layoutEditor;
  }
]);



// WEBPACK FOOTER //
// ./src/app/editor/services/layout_editor/layoutEditor.js